import store from './store';
import router from './router';
import {clearLoginCookie, isBaiduerType, messageToLoginPage} from './util/util.js';
import {ServiceCode} from './enmus/CommonCode';
import {getInfo} from './request/api';
import * as RouterUtil from '@/router/routerUtil';
import * as PageNames from '@/enmus/PageNames';
import {getCookie} from '@/util/util';
import {LoginTypeCookieKey} from '@/constant';

// 提前将之前选的的supplyId设置上去
// store.dispatch('initSupplyId');

function isIntroducePages(to) {
    return RouterUtil.isPage(PageNames.INTRODUCE_ROOT, to);
}

function isLogInPage(to) {
    return RouterUtil.isPage(PageNames.LOGIN, to);
}

function checkUserLoginStatus(response, next) {
    const {res, data} = response;
    const {supplyList, userType} = data;
    if (res !== 0) {
        // redirect to login
        messageToLoginPage('服务器异常，请重新登录', {
            confirmButtonText: '重新登录'
        });
        return false;
    } else if (!isBaiduerType(userType) && !supplyList?.length) {
        // 未分配权限
        next({name: PageNames.INTRODUCE_INDEX});
        return false;
    }
    return true;
}

router.beforeEach((to, from, next) => {
    if (isLogInPage(to) || isIntroducePages(to)) {
        next();
        return;
    }
    const accountType = getCookie(LoginTypeCookieKey);
    if (!accountType) {
        next({name: PageNames.LOGIN});
        return;
    }
    if (!store.state.init) {
        store.state.globalRequestError = false;
        // const user = JSON.parse(getCookie('userInfo') || null);
        getInfo()
            .then(response => {
                const data = response.data;
                const checkResult = checkUserLoginStatus(response, next);
                if (checkResult) {
                    const user = store.state.user;
                    if (!user || !store.state.init) {
                        store.dispatch('initAuth', data);
                    }
                    // 判断是否已申请了平台
                    store.dispatch('doInit').then(code => {
                        // 原百度系渠道的账号员工已离职，跳转到引导页
                        if (ServiceCode.FAIL === code) {
                            next({name: PageNames.INTRODUCE_INDEX});
                            return;
                        }
                    });
                    next();
                }
            })
            .catch(e => {
                console.error(e);
                const msg = e.message;
                if (msg.includes('Network Error')) {
                    // 网络错误处理
                    store.state.globalRequestError = true;
                }
                // console.log('进入页面前，获取权限，发生异常');
                next();
            });
    } else {
        next();
    }
});

router.afterEach((to, from, next) => {
    if (isLogInPage()) {
        // 清理登录信息
        clearLoginCookie();
    }
    window.scrollTo(0, 0);
});
